import { IconType } from "../Icon";
import { useAppSelector } from "../../hooks";
import { selectButton } from "../../store/slices/buttons";
import IconButton from "./IconButton";
import Commander from "../../commander";
import Slider from "../Slider";
import classes from "../../styles/Buttons.module.css";
import { useCallback, useEffect, useRef, useState } from "react";
import { areCoordinatesInArea } from "../../utils";

const getIconType = (mute: boolean, level: number): IconType => {
  if (mute) return "SoundOff";
  return level > 0.5 ? "SoundOn" : "SoundMid";
};

const SoundButton: React.FC<{}> = () => {
  const { mute, level } = useAppSelector((state) => state.details.sound);
  const type = getIconType(mute, level);
  const [hasSlider, setHasSlider] = useState(false);
  const [sliderOut, setSliderOut] = useState(false);
  const [buttonOut, setButtonOut] = useState(false);
  const { available, disabled } = useAppSelector(
    selectButton.bind(null, "sound")
  );
  const buttonRef = useRef(null);
  const onClick = () => Commander.toggleMute(!mute);
  const toggleSlider = useCallback((show: boolean) => {
    const state = show && !disabled && available;
    setHasSlider(show && !disabled && available);
    if (state) {
      setSliderOut(false);
      setButtonOut(false);
    }
  }, [available, disabled]);

  useEffect(() => {
    if (sliderOut && buttonOut) {
      toggleSlider(false);
    }
  }, [sliderOut, buttonOut, toggleSlider]);

  useEffect(() => {
    const onMouseOut = (e: MouseEvent) => {
      if (
        e.clientX >= window.innerWidth ||
        e.clientX < 0 ||
        e.clientY >= window.innerHeight ||
        e.clientY < 0
      ) {
        setButtonOut(true);
        setSliderOut(true);
      }
    };

    window.addEventListener("mouseout", onMouseOut);

    return () => window.removeEventListener("mouseout", onMouseOut);
  }, []);

  return (
    <div className={classes["button-sound-container"]}>
      <div
        className={classes["button-sound-container-inner"]}
        ref={buttonRef}
        onMouseEnter={() => toggleSlider(true)}
        onMouseLeave={(e: any) => {
          const rect = e.target.getBoundingClientRect();
          if (!areCoordinatesInArea(e.clientX, e.clientY, rect)) {
            setButtonOut(true);
            setSliderOut(true);
          }
        }}
      ></div>
      <IconButton
        name="sound"
        available={available}
        onClick={onClick}
        disabled={disabled}
        type={type}
        soundEffect="button-click"
        onHover={(e) => {
          const rect = (buttonRef.current as any).getBoundingClientRect();
          if (buttonOut && areCoordinatesInArea(e.clientX, e.clientY, rect)) {
            toggleSlider(true);
          }
        }}
      />
      <Slider
        size={120}
        ticknes={15}
        value={mute ? 0 : level}
        visible={hasSlider}
        orientation="horizontal"
        className="sound"
        onValueChange={(value) => Commander.setSoundLevel(value ?? 0)}
        onMouseLeave={(e) => {
          const rect = (buttonRef.current as any).getBoundingClientRect();
          setSliderOut(true);
          if (!areCoordinatesInArea(e.clientX, e.clientY, rect)) {
            setButtonOut(true);
          }
        }}
      />
    </div>
  );
};

export default SoundButton;
